import React from 'react';
import styles from './styles.module.scss';
import logo from '../../../assets/yellow-logo.png'
import { useNavigate } from 'react-router-dom';
import {paths} from "../../../constants/paths/common"
import { useMsal } from '@azure/msal-react';

const Header = () => {
  const { instance } = useMsal();
  const navigate = useNavigate()
  
  const logoutRequest = {
    account: instance.getAccountByHomeId(),
    mainWindowRedirectUri: process.env.REACT_APP_AUTH_REDIRECT,
    postLogoutRedirectUri: process.env.REACT_APP_AUTH_REDIRECT,
  }
  const handleLogout = () =>{
    localStorage.clear();
    instance.logoutPopup(logoutRequest).catch(e => {
      console.error(e);
    });
    navigate("/401")
  }
  return (
    <div className={styles.headerContainer}>
      <div className={styles.logo}>
        <img src={logo} alt="GIS logo" />
      </div>
      <div className={styles.logoutButton} onClick={()=>handleLogout(instance)}>Logout</div>
    </div>
  )
}

export default Header